const csvTemplate = `_id,customer_type_id
683d2e92f303d7a61f223680,
683ecb8c0ea38a11714fdb0e,
6847a0955d2558270ab1617a,
6847e76570a9cad957aa06a5,685d1f32ecc64f836cacfd7d
6847efda70a9cad957aa0847,685d1f32ecc64f836cacfd7d
68492f8922e7882733a7bf1b,685d23b7ecc64f836cacfeb1
68522ce6d0f5154167abf4cd,685d23b7ecc64f836cacfeb1
68522d3c407114529d9de0a4,685d23b7ecc64f836cacfeb1
68527e80407114529d9de6f5,685d23b7ecc64f836cacfeb1
685b9bb1e0cbc72ef6e3f859,685d23b7ecc64f836cacfeb1
685cb89bdb477c2b4069b24d,685d23b7ecc64f836cacfeb1`;

export default csvTemplate;
